import React from 'react'

interface SectionDividerProps {
  label?: string
  className?: string
}

/**
 * Simple section divider with optional label
 *
 * Provides visual separation between settings groups with light theme styling.
 */
export const SectionDivider: React.FC<SectionDividerProps> = ({ label, className = '' }) => {
  if (label) {
    return (
      <div className={`flex items-center gap-3 my-6 ${className}`}>
        <div className="flex-1 h-px bg-gray-200" />
        <span className="text-sm font-medium text-gray-500 uppercase tracking-wide">
          {label}
        </span>
        <div className="flex-1 h-px bg-gray-200" />
      </div>
    )
  }

  return <div className={`h-px bg-gray-200 my-6 ${className}`} />
}
